'use strict';

var MemberApp = angular.module('MemberApp');

MemberApp.directive('printStrongText', function() {
  return {
    restrict: 'E',
    templateUrl: 'scripts/directives/otpp-pension-modules/print-modules/print-strong-text-module.prt.html',
    link: function(scope, element, attrs) {
      scope.normalText = attrs.printtext;
      scope.strongText = attrs.printstrongtext;
    }
  };
});
